(() => {
  const ready = (fn) => document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn, { once: true }) : fn();
  ready(() => {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const motionItems = [...document.querySelectorAll('.opening-carousel__intro,.opening-carousel__card,.proof-editorial__paper,.fulfillment-photo,.release-list__inner,.documentation-path__steps article')];
    motionItems.forEach(item => item.classList.add('bts57-motion'));
    const show = item => item.classList.add('bts57-in-view');
    if (reduced || !('IntersectionObserver' in window)) motionItems.forEach(show);
    else {
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        show(entry.target);
        observer.unobserve(entry.target);
      }), { threshold: .08, rootMargin: '0px 0px -4% 0px' });
      motionItems.forEach(item => observer.observe(item));
      window.setTimeout(() => motionItems.forEach(show), 2500);
    }

    /* Eastern-time shipping status; weekends roll to the next business day. */
    let qualifies = false;
    try {
      const parts = Object.fromEntries(new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/New_York', weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false
      }).formatToParts(new Date()).filter(part => part.type !== 'literal').map(part => [part.type, part.value]));
      const businessDay = ['Mon','Tue','Wed','Thu','Fri'].includes(parts.weekday);
      const minutes = Number(parts.hour) * 60 + Number(parts.minute);
      qualifies = businessDay && minutes < 14 * 60;
    } catch (_) { qualifies = false; }
    document.querySelectorAll('[data-shipping-cutoff]').forEach(message => {
      message.textContent = qualifies ? message.dataset.before : message.dataset.after;
    });
  });
})();
